import { array, boolean, func, object, string, union, optional } from 'superstruct'

export const Provider = object({
  enabled: union([boolean(), func()]),
  createOrder: optional(func()),
  getAssets: func(),
  getCountries: func(),
  getOrder: func(),
  getPaymentMethod: func(),
  getQuote: func(),
  name: string(),
  orderTypes: array(string()),
  providers: optional(array()),
})
